import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';

/**
 * Drop-in replacement for react-router's Link that automatically
 * prepends the current language prefix to the `to` path.
 */
const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const localizedPath = useLocalizedPath();
    
    const localizedTo = typeof to === 'string' 
      ? localizedPath(to)
      : to;

    return <Link ref={ref} to={localizedTo} {...props} />;
  }
);

LocalizedLink.displayName = 'LocalizedLink';

export default LocalizedLink;
